/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_Q3Inputs */

const en_to_typescript_faq_q3 = /** @type {(inputs: To_Typescript_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle nested objects?`)
};

const ko_to_typescript_faq_q3 = /** @type {(inputs: To_Typescript_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩된 객체도 처리되나요?`)
};

const ja_to_typescript_faq_q3 = /** @type {(inputs: To_Typescript_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストされたオブジェクトに対応していますか？`)
};

/**
* | output |
* | --- |
* | "Does it handle nested objects?" |
*
* @param {To_Typescript_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_q3 = /** @type {((inputs?: To_Typescript_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_q3(inputs)
	if (locale === "ko") return ko_to_typescript_faq_q3(inputs)
	return ja_to_typescript_faq_q3(inputs)
});